"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _tabs = require("../tabs/tabs");

var MobilePanel =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "e16i77hj0"
})(function (_ref) {
  var selected = _ref.selected;
  return selected ? {
    display: 'block',
    position: 'fixed',
    top: 0,
    left: 0,
    height: 'calc(100vh - 40px)',
    width: '100vw',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch'
  } : {
    display: 'none'
  };
});
var TabsWrapper =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "e16i77hj1"
})({
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100vw',
  zIndex: 9999
});
var MobileTabs = ['Navigator', 'Preview', 'Addons'];

var Layout =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Layout, _Component);

  function Layout() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Layout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Layout)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      index: 1
    });
    return _this;
  }

  (0, _createClass2.default)(Layout, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var index = this.state.index;
      var children = this.props.children;
      return _react.default.createElement("div", null, _react.default.createElement(TabsWrapper, null, _react.default.createElement(_tabs.TabBar, null, children.map(function (item, i) {
        return _react.default.createElement(_tabs.Tab, {
          key: MobileTabs[i],
          name: MobileTabs[i],
          active: i === index,
          title: MobileTabs[i] || "".concat(i),
          onSelect: function onSelect() {
            return _this2.setState({
              index: i
            });
          }
        });
      }))), _react.Children.toArray(children).map(function (item, i) {
        return _react.default.createElement(MobilePanel, {
          key: MobileTabs[i],
          selected: i === index
        }, item);
      }));
    }
  }]);
  return Layout;
}(_react.Component);

exports.default = Layout;
Layout.propTypes = {
  children: _propTypes.default.node.isRequired
};